import {Component, OnInit} from '@angular/core';
import {CrudService} from "@core/shared/services/crud.service";
import {CrudAction} from "@core/shared/models/crud";

@Component({
    selector: 'app-core-page-society-group-create',
    templateUrl: './page-society-group-create.component.html',
    styleUrls: ['./page-society-group-create.component.scss'],
    providers: [
        CrudService
    ],
    standalone: false
})
export class PageSocietyGroupCreateComponent implements OnInit {

    constructor(
        private _crudService: CrudService
    ) {}

    ngOnInit() {

        this._crudService.setAction(CrudAction.Create);
    }
}
